import { css } from 'styled-components';

export default css`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
  grid-gap: 10px;
  .cx-time-zone-country {
    margin-right: 15px;
  }
`;
